export {default} from './signal.vue'